import { Component } from 'react'
import debounce from 'lodash/debounce'

const EVENT_RESIZE = `resize`

const getSize = () => {
	const { clientHeight: height = 0, clientWidth: width = 0 } =
		window.document.body || {}

	return { height, width }
}

class WindowResizeListener extends Component {
	componentDidMount() {
		const { debounceTime = 100 } = this.props

		this.listener = debounce(this.onResize, debounceTime)
		window.addEventListener(EVENT_RESIZE, this.listener)
		this.onResize()
	}

	componentWillUnmount() {
		window.removeEventListener(EVENT_RESIZE, this.listener)
	}

	onResize = () => {
		const { onResize } = this.props
		onResize && onResize(getSize())
	}

	render() {
		return null
	}
}

export default WindowResizeListener
